<template>
  <div class="course-maintenance">
    <div class="layout clearfix">
      <navBack backUrl="/teacher"></navBack>

      <div class="edit-course">
        <div class="abstract-cover clearfix">
          <div class="abstract-info">
            <div class="course-title">{{ course.title }}</div>
            <div class="tag-list">
              <ul>
                <li v-for="(tag, index) in course.tags" :key="index">
                  {{ tag.name }}
                </li>
              </ul>
            </div>
            <div class="course-desc">
              <div class="course-content jian-shu">
                {{ course.summary }}
              </div>
              <div class="course-content">{{ course.content }}</div>
            </div>
            <div class="create-time">创建时间：{{ course.createTime }}</div>
          </div>
          <div class="cover-info" v-if="name">
            <div class="edit-status">课程状态：{{ course.statusName }}</div>
            <div class="cover-img">
              <img :src="baseUrl + course.imgUrl" alt="" class="cover-img" />
            </div>
            <div class="btn-list">
              <el-button
                type="primary"
                size="small"
                v-for="(btn, index) in buttons"
                :key="index"
                :disabled="disabled(btn.status)"
                @click="handleButton(btn.status)"
              >
                {{ btn.text }}
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="edit-course">
        <div class="course-content">
          <div class="title">案例</div>
          <div class="list clearfix">
            <div class="item" v-for="(chapter, index) in chapters" :key="index">
              <div class="cover-img" @click="handleDetail(chapter)">
                <el-image
                  :src="baseUrl + chapter.imgUrl"
                  style="width: 100%; height: 100%"
                  fit="cover"
                  alt="章节封面"
                />
              </div>
              <div class="course-title">{{ chapter.title }}</div>
              <div class="course-summary">
                {{ chapter.content }}
              </div>
              <div class="btn-box clearfix" v-if="course.status == 0">
                <div class="btn edit" @click="editChapter(chapter.code)">
                  编辑
                </div>
                <!-- <div class="btn del" @click="deleteChapter(chapter.id)">
                  删除
                </div> -->
                <div class="rside">
                  <div
                    class="btn prev"
                    @click="moveChapter(index, 'up')"
                    :class="{ disabled: index === 0 }"
                  ></div>
                  <div
                    class="btn next"
                    @click="moveChapter(index, 'down')"
                    :class="{ disabled: index === chapters.length - 1 }"
                  ></div>
                </div>
              </div>
            </div>
            <div v-if="name" class="add-btn" @click="addChapter"></div>
          </div>
        </div>
      </div>

      <!-- 添加或修改内容管理-场景内容对话框 -->
      <el-dialog :title="title" :visible.sync="open" width="80%" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item label="案例名称" prop="title">
            <el-input v-model="form.title" placeholder="请输入标题" />
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="form.type" style="width: 100%">
              <el-option
                v-for="dict in typeOptions"
                :key="dict.id"
                :label="dict.name"
                :value="dict.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="案例说明" prop="content">
            <el-input
              v-model="form.content"
              maxlength="20"
              show-word-limit
              type="textarea"
              placeholder="请输入内容"
            />
          </el-form-item>
          <el-form-item label="案例封面">
            <imageUpload
              :value="caseImgList"
              @input="handleCaseFileUpload"
            ></imageUpload>
          </el-form-item>

          <el-form-item label="案例相关视频">
            <file-upload
              :fileType="['mp4']"
              v-model="form.videoUrl"
            ></file-upload>
          </el-form-item>

          <div class="scene-list">
            <div v-for="(item, index) in scenes" :key="index">
              <el-card class="box-card">
                <div class="upload-section">
                  <label class="sceneName">场景文件：</label>
                  <el-upload
                    action="123"
                    :http-request="(file) => handleUploadExcel(file, index)"
                  >
                    <el-button size="small" type="primary">选取文件</el-button>
                  </el-upload>
                </div>
                <div class="upload-section">
                  <label class="sceneName">数字人文件：</label>
                  <file-upload
                    :fileType="['webm']"
                    v-model="item.videoUrl"
                  ></file-upload>
                </div>
                <div class="upload-section">
                  <label class="sceneName">场景名称：</label>
                  <el-input
                    v-model="item.title"
                    placeholder="请输入场景名称"
                  ></el-input>
                </div>
                <!-- <div class="upload-section">
                  <label class="sceneName">场景简述：</label>
                  <el-input
                    v-model="item.summary"
                    maxlength="20"
                    show-word-limit
                    placeholder="请输入场景简述"
                  ></el-input>
                </div> -->
              </el-card>

              <div class="scene-controls">
                <el-button
                  type="primary"
                  icon="el-icon-arrow-left"
                  :disabled="index === 0"
                  @click="moveScene(index, 'up')"
                ></el-button>
                <el-button
                  type="primary"
                  icon="el-icon-arrow-right"
                  :disabled="index === scenes.length - 1"
                  @click="moveScene(index, 'down')"
                ></el-button>
                <el-button
                  type="primary"
                  icon="el-icon-delete"
                  @click="deleteScene(index)"
                ></el-button>
              </div>
            </div>
            <div class="add-btn-scene" @click="addScene"></div>
          </div>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 使用 el-dialog 替代原生的 div 模态框 -->
      <el-dialog
        title="修改课程"
        :visible.sync="showAddCourse"
        width="50%"
        :close-on-click-modal="false"
      >
        <!-- 表单结构使用 el-form 包裹 -->
        <el-form :model="newCourse" label-width="120px">
          <!-- 课程名称 -->
          <el-form-item label="课程名称：">
            <el-input
              v-model="newCourse.title"
              placeholder="请输入课程名称"
            ></el-input>
          </el-form-item>

          <!-- 课程封面 -->
          <el-form-item label="课程封面：">
            <span class="tip">建议尺寸16:9</span>
            <!-- 使用 el-upload 组件替换原来的 imageUpload -->
            <imageUpload
              :value="imgList"
              @input="handleFileUpload"
            ></imageUpload>
          </el-form-item>

          <!-- 课程说明 -->
          <el-form-item label="课程说明：">
            <el-input
              type="textarea"
              :rows="4"
              v-model="newCourse.content"
              placeholder="请输入课程说明"
            ></el-input>
          </el-form-item>

          <el-form-item label="标签：">
            <el-select
              v-model="newCourse.tagsIds"
              style="width: 100%"
              multiple
              placeholder="请选择标签"
            >
              <el-option
                v-for="item in tags"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否匿名访问：">
            <el-radio-group v-model="newCourse.anon">
              <el-radio :label="0">不可以</el-radio>
              <el-radio :label="1">可以</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 提交与取消按钮 -->
          <el-form-item>
            <div class="btns">
              <el-button @click="closeAddCourseModal">取消</el-button>
              <el-button type="primary" @click="createCourse">
                修改课程
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  deleteContentCourse,
  getContentDetail,
  getHouseList,
  getCaseList,
  editCourse,
  contentSort,
  getContentTags,
  buildAi,
  getSkyDetail,
} from "@/api/index";
import { mapState } from "vuex";
import {
  listContent,
  getContent,
  delContent,
  addContent,
  addCaseContent,
  updateContent,
  uploadScene,
} from "@/api/manage/content";
import { allListType } from "@/api/manage/type";
export default {
  name: "CourseMaintenance",
  data() {
    return {
      activeName: "1",
      course: {},
      buttons: [
        {
          text: "对内",
          action: "abon",
          status: "3",
          isShow: true,
          publicStatus: 0,
        },
        { text: "发布", action: "publish", status: "1", isShow: true },
        { text: "修改", action: "edit", status: "0", isShow: true },
        { text: "停止", action: "stop", status: "2", isShow: true },
        { text: "成绩", action: "score", status: "4", isShow: true },
      ],
      chapters: [],
      // 弹出层标题
      title: "",
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        title: [{ required: true, message: "请输入案例名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择案例类型", trigger: "change" },
        ],
        content: [
          { required: true, message: "请输入案例说明", trigger: "blur" },
        ],
      },
      // 是否显示弹出层
      open: false,
      typeOptions: [],
      subjectId: "",
      showAddCourse: false,
      newCourse: {
        title: "",
        imgUrl: "",
        content: "",
        anon: 1, // 是否匿名访问，默认可以
        tagsIds: [], // 标签ID数组
      },
      tags: [],
      imgList: [],
      aiPrompt: "",
      downloadUrl: "",
      loading: false,
      scenes: [],
      currentSceneIndex: 0,
      currentSceneName: "",
      previewImage: null,
      caseImgList: [], // 案例图片
      caseCode: "",
    };
  },
  computed: {
    ...mapState(["baseUrl", "name"]),
  },
  created() {
    // 获取参数
    const urlCode = this.$route.params.id;
    this.subjectId = urlCode;

    this.fetchChapters(urlCode);

    // 获取课程 内容
    this.fetchClassContent();

    this.getTypeOptions();

    this.fetchTags();
  },
  methods: {
    disabled(status) {
      if (this.course.status == 0) {
        //  编辑中
        if (status == 3 || status == 2 || status == 4) {
          return true;
        } else {
          return false;
        }
      } else if (this.course.status == 1) {
        // 考核中
        if (status == 1) {
          return true;
        } else {
          return false;
        }
      } else if (this.course.status == 2) {
        return true;
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 获取标签列表
    fetchTags() {
      getContentTags().then((res) => {
        if (res.code !== 200) {
          this.$message.error("获取标签列表失败");
          return;
        }
        this.tags = res.data || [];
      });
    },
    closeAddCourseModal() {
      this.showAddCourse = false;
      this.resetNewCourse();
    },
    resetNewCourse() {
      this.newCourse = {
        title: "",
        imgUrl: "",
        content: "",
        anon: 1, // 是否匿名访问，默认可以
        tagsIds: [], // 标签ID数组
      };
    },
    handleFileUpload(file) {
      this.newCourse.imgUrl = file;
    },
    createCourse() {
      if (!this.newCourse.title.trim()) {
        this.$message.error("请输入课程名称");
        return;
      }

      if (!this.newCourse.imgUrl) {
        this.$message.error("请上传课程封面");
        return;
      }
      const params = {
        ...this.newCourse,
      };
      addCourse(params)
        .then((response) => {
          if (response.code === 200) {
            this.$message.success("课程修改成功");
          } else {
            this.$message.error(response.msg || "课程修改失败");
          }
        })
        .catch((error) => {
          console.error("修改失败:", error);
          this.$message.error("课程修改失败，请稍后再试");
        });
    },
    getTypeOptions() {
      this.typeOptions = [];
      allListType().then((response) => {
        this.typeOptions = response.data;
      });
    },
    handleDetail(chapter) {
      this.$router.push({
        path: "/skyBox",
        query: { id: chapter.code },
      });
    },
    fetchClassContent() {
      getCaseList({ subjectCode: this.subjectId }).then((res) => {
        if (res && res.code == 200) {
          this.chapters = res.rows || [];
        }
      });
    },
    fetchChapters(urlCode) {
      getContentDetail({ urlCode })
        .then((res) => {
          if (res.code === 200) {
            this.course = res.data;
            if (this.course.imgUrl) {
              this.imgList.push(this.course.imgUrl);
            }
            if (this.course.tagsIds) {
              this.$set(this.newCourse, "tagsIds", this.course.tagsIds);
            }
            // 根据publicStatus设置按钮文字和显示状态
            if (this.course.publicStatus == 1) {
              this.$set(this.buttons[0], "text", "对内");
              this.$set(this.buttons[0], "isShow", false);
            } else {
              this.$set(this.buttons[0], "text", "对外");
              this.$set(this.buttons[0], "isShow", true);
            }
          } else {
            this.$message.error("获取课程内容失败：" + res.message);
          }
        })
        .catch((error) => {
          this.$message.error("获取课程内容失败：" + error.message);
        });
    },
    handleButton(action) {
      if (action == 0) {
        this.showAddCourse = true;
        this.newCourse = this.course;
      } else if (action == 3) {
        // 切换对外/对内状态
        const currentPublicStatus = this.course.publicStatus || 0;
        const newPublicStatus = currentPublicStatus === 1 ? 0 : 1;

        const params = {
          ...this.course,
          publicStatus: newPublicStatus,
        };

        editCourse(params)
          .then(() => {
            // 更新本地状态
            this.course.publicStatus = newPublicStatus;

            this.$message.success("操作成功");
            this.fetchChapters(this.subjectId);
          })
          .catch(() => {
            this.$message.error("操作失败，请重试");
          });
      } else if (action == 4) {
        this.$router.push({
          path: "/exam",
          query: {
            code: this.subjectId,
            title: this.course.title,
            teacherName: this.course.teacherName,
          },
        });
      } else {
        const params = {
          ...this.course,
          status: action,
        };
        editCourse(params).then(() => {
          this.$message.success("课程编辑成功！");
          this.fetchChapters(this.subjectId);
        });
      }
    },
    publishCourse() {
      this.$message.success("课程已发布成功！");
      this.course.status = "已发布";
    },
    stopCourse() {
      this.$message.warning("课程已停止");
      this.course.status = "已停止";
    },
    viewScore() {
      this.$message.info("查看学生成绩");
    },
    addChapter() {
      this.reset();
      this.resetScenes();
      this.open = true;
      this.title = "添加案例";
    },
    editChapter(code) {
      this.caseCode = code;
      this.reset();
      this.resetScenes();

      // 获取案例详情
      const params = { id: code };
      getSkyDetail(params)
        .then((response) => {
          if (response && response.code === 200) {
            const caseData = response.data;

            // 填充表单数据
            this.form = {
              id: caseData.id,
              title: caseData.title,
              content: caseData.content,
              type: caseData.type,
              imgUrl: caseData.imgUrl,
              videoUrl: caseData.videoUrl,
              code: caseData.code,
            };

            // 填充场景数据
            if (caseData.contents && caseData.contents.length > 0) {
              this.scenes = caseData.contents.map((scene) => ({
                title: scene.title,
                videoUrl: scene.videoUrl,
                imgUrl: scene.imgUrl,
                sceneDir: scene.sceneDir,
              }));
            }

            // 设置案例图片
            if (caseData.imgUrl) {
              this.caseImgList = [caseData.imgUrl];
            }

            this.open = true;
            this.title = "修改案例";
          } else {
            this.$message.error("获取案例详情失败");
          }
        })
        .catch((error) => {
          console.error("获取案例详情失败:", error);
          this.$message.error("获取案例详情失败");
        });
    },
    deleteChapter(id) {
      const ids = id;
      this.$modal
        .confirm('是否确认删除内容管理-场景内容编号为"' + ids + '"的数据项？')
        .then(function () {
          return delContent(ids);
        })
        .then(() => {
          this.fetchClassContent();
          this.$modal.msgSuccess("删除成功");
        })
        .catch(() => {});
    },
    moveChapter(index, direction) {
      if (direction === "up" && index > 0) {
        const temp = this.chapters[index];
        this.$set(this.chapters, index, this.chapters[index - 1]);
        this.$set(this.chapters, index - 1, temp);
      } else if (direction === "down" && index < this.chapters.length - 1) {
        const temp = this.chapters[index];
        this.$set(this.chapters, index, this.chapters[index + 1]);
        this.$set(this.chapters, index + 1, temp);
      }
      // 拿到移动后的ids
      const ids = this.chapters.map((item) => item.id);
      // 表单提交
      const formData = new FormData();
      formData.append("ids", ids);
      contentSort(formData).then(() => {
        this.$message.success("排序成功");
      });
    },
    addScene() {
      if (this.scenes.length >= 6) {
        this.$message.warning("最多只能添加6个场景");
        return;
      }
      this.scenes.push({
        title: "",
        videoUrl: "",
        imgUrl: "",
        sceneDir: "",
      });
    },
    handleUploadExcel(fileParam, index) {
      this.$modal.loading("正在上传文件，请稍候...");
      const formData = new FormData();
      formData.append("file", fileParam.file);
      uploadScene(formData).then((res) => {
        if (res.code === 200) {
          this.$set(this.scenes, index, {
            ...this.scenes[index],
            imgUrl: res.imgUrl,
            sceneDir: res.sceneDir,
          });
        }
        this.$modal.closeLoading();
      });
    },
    handleCaseFileUpload(file) {
      this.form.imgUrl = file;
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
      this.resetScenes();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        title: null,
        content: null,
        type: null,
        fileId: null,
        createTime: null,
        createBy: null,
        updateTime: null,
        updateBy: null,
        imgUrl: null,
        videoUrl: null,
        code: null,
      };
    },
    // 重置场景数据
    resetScenes() {
      this.scenes = [];
      this.caseImgList = [];
    },
    // 验证场景数据
    validateScenes() {
      if (this.scenes.length === 0) {
        this.$message.warning("请至少添加一个场景");
        return false;
      }

      for (let i = 0; i < this.scenes.length; i++) {
        const scene = this.scenes[i];
        if (!scene.title || !scene.title.trim()) {
          this.$message.warning(`请填写第${i + 1}个场景的名称`);
          return false;
        }
        if (!scene.imgUrl) {
          this.$message.warning(`请上传第${i + 1}个场景的场景文件`);
          return false;
        }
        if (!scene.videoUrl) {
          this.$message.warning(`请上传第${i + 1}个场景的数字人文件`);
          return false;
        }
      }

      return true;
    },
    /** 提交按钮 */
    submitForm() {
      if (this.activeName == "1") {
        console.log("this.scenes", this.scenes);
        console.log("this.form", this.form);

        this.$refs["form"].validate((valid) => {
          if (valid && this.validateScenes()) {
            const formData = {
              ...this.form,
              subjectCode: this.subjectId,
              contents: this.scenes,
            };

            if (this.form.id != null) {
              // 更新案例
              addCaseContent(formData, "put")
                .then((response) => {
                  if (response && response.code === 200) {
                    this.$modal.msgSuccess("修改成功");
                    this.open = false;
                    this.fetchClassContent();
                  } else {
                    this.$message.error("修改失败");
                  }
                })
                .catch((error) => {
                  console.error("修改案例失败:", error);
                  this.$message.error("修改失败");
                });
            } else {
              // 新增案例
              addCaseContent(formData)
                .then((response) => {
                  if (response && response.code === 200) {
                    this.$modal.msgSuccess("新增成功");
                    this.open = false;
                    this.fetchClassContent();
                  } else {
                    this.$message.error("新增失败");
                  }
                })
                .catch((error) => {
                  console.error("新增案例失败:", error);
                  this.$message.error("新增失败");
                });
            }
          }
        });
      } else {
        this.open = false;
        this.fetchClassContent();
      }
    },
    generateCase() {
      if (!this.aiPrompt.trim()) {
        this.$notify({
          title: "提示",
          message: "请输入生成描述",
          type: "warning",
        });
        return;
      }
      const params = {
        userInput:
          // this.aiPrompt ||
          "在某天下午，大雨，某机场，两架飞机相撞，起火，2人受伤",
      };
      this.loading = true;
      buildAi(params).then((result) => {
        if (result && result.code == 200) {
          this.downloadUrl = result.msg;
          this.$message.success("生成成功");
        }
        this.loading = false;
      });

      this.showResult = true;
      this.progress = 35;

      // 模拟生成进度
      const interval = setInterval(() => {
        this.progress += 5;
        if (this.progress >= 100) {
          clearInterval(interval);
          this.progress = 100;
          this.steps[3].status = "complete";
          this.steps[3].icon = "fas fa-check";
          this.steps[4].status = "progress";
          this.steps[4].icon = "fas fa-spinner fa-spin";
        }
      }, 1000);
    },
    handleUpload(itemName) {},
    moveScene(index, direction) {
      if (direction === "up" && index > 0) {
        const temp = this.scenes[index];
        this.$set(this.scenes, index, this.scenes[index - 1]);
        this.$set(this.scenes, index - 1, temp);
      } else if (direction === "down" && index < this.scenes.length - 1) {
        const temp = this.scenes[index];
        this.$set(this.scenes, index, this.scenes[index + 1]);
        this.$set(this.scenes, index + 1, temp);

        console.log("this.scenes", this.scenes);
      }
    },
    deleteScene(index) {
      this.$confirm("确定删除该场景吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.scenes.splice(index, 1);
          this.$message.success("删除成功");
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    handleFileChange(file) {
      console.log("File changed:", file);
    },
    getSkyDetail() {
      const params = {
        id: this.caseCode,
      };
      getSkyDetail(params)
        .then((response) => {
          if (response && response.code == 200) {
            this.skyDetail = response.data;
            this.videoUrl = this.skyDetail.videoUrl;
            this.currentTitle = this.skyDetail.title;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-button--primary.is-disabled,
::v-deep .el-button--primary.is-disabled:active,
::v-deep .el-button--primary.is-disabled:focus,
::v-deep .el-button--primary.is-disabled:hover {
  background-color: #fff !important;
  border-color: #ebeef5 !important;
  color: #c0c4cc !important;
  box-shadow: none !important;
}

.course-maintenance {
  min-height: 100vh;
  padding: 30px 24px 70px;
  background:
    radial-gradient(circle at 8% 0%, rgba(47, 111, 237, 0.09), transparent 34%),
    radial-gradient(circle at 94% 3%, rgba(244, 104, 36, 0.10), transparent 30%),
    linear-gradient(180deg, #f7faff 0%, #f5f7fb 48%, #ffffff 100%);
}

.layout {
  width: min(1180px, 100%);
  margin: 0 auto;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.edit-course {
  padding: 24px;
  margin-bottom: 22px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(226, 232, 240, 0.92);
  box-shadow: var(--shadow-card);
}

.abstract-cover {
  display: grid;
  grid-template-columns: 1fr 330px;
  gap: 22px;
  align-items: start;
}

.abstract-info {
  min-width: 0;
}

.course-title {
  margin: 0 0 14px;
  color: var(--brand-blue-deep);
  font-size: 28px;
  line-height: 1.22;
  font-weight: 900;
}

.course-summary {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: var(--gray-text);
  font-size: 15px;
  line-height: 1.7;
}

.tag-list ul {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 0 0 18px;
  padding: 0;
}

.tag-list li {
  display: inline-flex;
  align-items: center;
  padding: 6px 11px;
  border-radius: 999px;
  background: rgba(47, 111, 237, 0.10);
  color: var(--secondary-color);
  font-size: 13px;
  font-weight: 800;
}

.course-desc {
  margin: 14px 0 16px;
  color: var(--gray-text);
  font-size: 15px;
  line-height: 1.85;
}

.course-content.jian-shu {
  margin-bottom: 10px;
  color: var(--dark-text);
  font-weight: 700;
}

.create-time {
  color: var(--muted-text);
  font-size: 14px;
}

.cover-info {
  min-width: 0;
}

.edit-status {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(244, 104, 36, 0.10);
  color: var(--primary-color);
  font-size: 15px;
  font-weight: 900;
  margin-bottom: 14px;
}

.cover-info .cover-img {
  width: 100%;
  height: 188px;
  overflow: hidden;
  border-radius: 22px;
  margin-bottom: 16px;
  background: #eef4ff;
  border: 1px solid rgba(226, 232, 240, 0.92);
}

.cover-info .cover-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.btn-list {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
}

.btn-list ::v-deep .el-button {
  width: 100%;
  min-width: 0;
  margin: 0 !important;
  padding: 9px 0;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 800;
}

@media (max-width: 860px) {
  .btn-list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.course-content .title {
  margin: 0 0 18px;
  color: var(--brand-blue-deep);
  font-size: 22px;
  font-weight: 900;
}

.list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(248px, 1fr));
  gap: 18px;
}

.item {
  overflow: hidden;
  border-radius: 22px;
  background: #fff;
  border: 1px solid rgba(226, 232, 240, 0.92);
  transition: all 0.24s ease;
}

.item:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 30px rgba(15, 47, 95, 0.10);
}

.item > .cover-img,
.add-btn,
.add-btn-scene {
  width: 100%;
  height: 158px;
  overflow: hidden;
  border-radius: 20px 20px 0 0;
  background: #eef4ff;
}

.item > .cover-img {
  cursor: pointer;
}

.item > .cover-img .el-image,
.item > .cover-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item .course-title {
  min-height: 52px;
  margin: 0;
  padding: 16px 16px 8px;
  font-size: 16px;
  line-height: 1.45;
}

.item .course-summary {
  padding: 0 16px 16px;
}

.btn-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 16px;
}

.btn-box .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 64px;
  height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  background: rgba(47, 111, 237, 0.10);
  color: var(--secondary-color);
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.btn-box .btn.edit {
  background: rgba(244, 104, 36, 0.10);
  color: var(--primary-color);
}

.rside {
  display: flex;
  gap: 8px;
}

.prev::before {
  content: "↑";
}

.next::before {
  content: "↓";
}

.btn.disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.add-btn,
.add-btn-scene {
  min-height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed rgba(47, 111, 237, 0.36);
  background: rgba(47, 111, 237, 0.05);
  cursor: pointer;
  position: relative;
}

.add-btn::before,
.add-btn-scene::before {
  content: "+";
  color: var(--secondary-color);
  font-size: 44px;
  font-weight: 300;
}

.scene-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 18px;
}

.scene-controls {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.sceneName {
  padding: 12px 16px;
  color: var(--brand-blue-deep);
  font-size: 15px;
  font-weight: 900;
}

.upload-section,
.box-card {
  border-radius: 18px;
  border: 1px solid rgba(226, 232, 240, 0.92);
  background: #fff;
}

.tip {
  color: var(--muted-text);
  font-size: 13px;
}

.btns,
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

::v-deep .el-dialog {
  border-radius: 20px;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  padding: 22px 26px;
  background: #f8fafc;
  border-bottom: 1px solid rgba(226, 232, 240, 0.9);
}

::v-deep .el-dialog__title {
  color: var(--brand-blue-deep);
  font-weight: 900;
}


.edit-course {
  position: relative;
}

.edit-course::before {
  content: "";
  position: absolute;
  left: 24px;
  top: 0;
  width: 58px;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--secondary-color), var(--accent-color));
}

.course-content .title::before {
  content: "Scenario Cases";
  display: block;
  margin-bottom: 6px;
  color: var(--secondary-color);
  font-size: 12px;
  letter-spacing: 0.4px;
  font-weight: 800;
}

@media (max-width: 900px) {
  .abstract-cover {
    grid-template-columns: 1fr;
  }

  .course-maintenance {
    padding: 24px 16px 56px;
  }

  .edit-course {
    padding: 22px;
  }
}
</style>
